const __t = (chiave) => bsstracking?.messaggi[chiave] ?? chiave

export default __t;